import React from 'react';

const Footer = () => {
    return (
        <div className='bg-black py-4 mt-4'>
        <div>
            <h5 className='text-white mb-2'>Contact Information</h5>
            <p className='text-white mb-0'>Email: talukderars@gmail.com</p>
            <p className='text-white'>phone: +8801629396785</p>

        </div>

    </div>
    );
};

export default Footer;